import { Component, h, Host, JSX, Prop } from "@stencil/core";
import { GlobalDataLayerService } from "../../../../shared/services/analytics/global-data-layer-service";
import {
  ClickElementTypes,
  ElementTypes,
  EventActions,
} from "../../../../shared/utility/constants";
import analyticsManager from "../../../../shared/services/analytics/analytics-manager";
import { getCurrentRoute } from "../../../../shared/services/routing-manager";

@Component({
  tag: "phn-nd-back-button",
  styleUrl: "back-button.scss",
  scoped: true,
})
export class BackButton {
  @Prop() text = "";

  @Prop() analyticsId = "";

  private sendDataLayerEvent() {
    GlobalDataLayerService.getInstance().pushDataLayerEvent(
      EventActions.MENU_BACK_CLICK,
      {
        componentClick: {
          clickElementId: this.analyticsId,
          clickElementName: this.text,
          clickElementType: ClickElementTypes.Button,
        },
        componentDisplay: {
          displayElementId: analyticsManager.calculateDisplayElementId(),
          displayElementType: analyticsManager.calculateDisplayElementType(
            getCurrentRoute(),
            ElementTypes.backButton,
            true,
          ),
          displayElementName: this.text,
        },
      },
    );
  }

  render(): JSX.Element {
    return (
      <Host>
        <phn-p-button-pure
          size="inherit"
          icon="arrow-left"
          class="back-button-text-link"
          aria={{ "aria-label": "Back to Menu" }}
          onClick={() => this.sendDataLayerEvent()}
        >
          {this.text}
        </phn-p-button-pure>
      </Host>
    );
  }
}
